import React, { useState } from 'react';
import TextInput from './../../../common/TextInput/index';
import Select from './../../../common/Select/index';
import TextArea from './../../../common/TextArea/index';
import { connect } from 'react-redux';
import { formSubmissionRequested, clearFormMessage } from '../actions';
import { getFormMessage, isFormSubmitting } from '../selectors';
import { PropTypes } from 'prop-types';

import './styles.scss';

function RequestForm({
    onFormSubmit,
    formMessage,
    onMessageDisplay,
    isFormSubmissionRequested,
}) {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [organization, setOrganization] = useState('');
    const [purpose, setPurpose] = useState('');
    const [expandedData, setExpandedData] = useState('');
    const [reference, setReference] = useState('');
    const [extraInfo, setExtraInfo] = useState('');

    const RefreshState = () => {
        setName('');
        setEmail('');
        setPhone('');
        setOrganization('');
        setPurpose('');
        setExpandedData('');
        setReference('');
        setExtraInfo('');
    };

    const btnText = isFormSubmissionRequested
        ? 'Sending...'
        : 'Send Your Data Request';

    return (
        <section className="RequestForm">
            <div className="container">
                <div className="verticalSpace">
                    <div className="row">
                        <div className="col-lg-9 mx-auto">
                            <form
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    onFormSubmit(
                                        name,
                                        email,
                                        phone,
                                        organization,
                                        purpose,
                                        reference,
                                        extraInfo,
                                        expandedData,
                                    );
                                    setTimeout(() => {
                                        RefreshState();
                                        onMessageDisplay();
                                    }, 10000);
                                }}
                            >
                                <div className="text-center">
                                    <h1 className="f-64 p-0 extraBold">
                                        Expanded Data Request Form For Over
                                        50,000 Pieces
                                    </h1>
                                </div>
                                <div className="requestFormWrapper">
                                    <div className="form-group">
                                        <TextInput
                                            placeholder="Name"
                                            value={name}
                                            required="required"
                                            onChange={(event) =>
                                                setName(event.target.value)
                                            }
                                        />
                                    </div>
                                    <div className="form-group">
                                        <TextInput
                                            type="email"
                                            placeholder="Email"
                                            value={email}
                                            required="required"
                                            onChange={(event) =>
                                                setEmail(event.target.value)
                                            }
                                        />
                                    </div>
                                    <div className="form-group">
                                        <TextInput
                                            type="number"
                                            placeholder="Phone (Optional)"
                                            value={phone}
                                            onChange={(event) =>
                                                setPhone(event.target.value)
                                            }
                                        />
                                    </div>
                                    <div className="form-group">
                                        <TextInput
                                            type="text"
                                            placeholder="Name of Organization"
                                            required="required"
                                            value={organization}
                                            onChange={(event) =>
                                                setOrganization(
                                                    event.target.value,
                                                )
                                            }
                                        />
                                    </div>
                                    <div className="form-group select">
                                        <Select
                                            label="Purpose for Data"
                                            required="required"
                                            items={[
                                                'Research',
                                                'Citizen Science',
                                                'School/ University Projects',
                                                'Data & Trend Analysis',
                                                'Informing City/ Country Policy',
                                                'Other',
                                            ]}
                                            value={purpose}
                                            onChange={(event) =>
                                                setPurpose(event.target.value)
                                            }
                                        />
                                    </div>
                                    <div className="form-group">
                                        <TextInput
                                            type="text"
                                            placeholder="Please share the details of the expanded data you would like to access [i.e. location, time, tags, etc]"
                                            value={expandedData}
                                            required="required"
                                            onChange={(event) =>
                                                setExpandedData(
                                                    event.target.value,
                                                )
                                            }
                                        />
                                    </div>
                                    <div className="form-group">
                                        <TextInput
                                            type="text"
                                            placeholder="How did you hear about Litterati?"
                                            value={reference}
                                            onChange={(event) =>
                                                setReference(event.target.value)
                                            }
                                        />
                                    </div>
                                    <div className="form-group">
                                        <TextArea
                                            rows={5}
                                            placeholder="Anything else you want us to know about your request?"
                                            value={extraInfo}
                                            onChange={(event) =>
                                                setExtraInfo(event.target.value)
                                            }
                                        />
                                    </div>
                                    <div className="row justify-content-center pl-2 pr-2 text-center">
                                        <button
                                            type={'submit'}
                                            className="btn btn-primary btn-pill"
                                            disabled={isFormSubmissionRequested}
                                        >
                                            {btnText}
                                        </button>
                                    </div>
                                    <div className="row justify-content-center pl-2 pr-2 text-center">
                                        {formMessage && formMessage === 1 && (
                                            <>
                                                <div className="text-center font-weight-bold pt-1">
                                                    Thank You. Your data request
                                                    has been sent. You will hear
                                                    back from us in 1 - 4
                                                    business days.
                                                </div>
                                                <div className="text-center font-weight-bold pt-1">
                                                    If you want to request more
                                                    data, fill out the form
                                                    again & if you have any
                                                    questions, email
                                                    support@litterati.org
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </form>

                            <div className="form-bottom-text text-left">
                                <p>
                                    {`The Global Litter Database has been generated by the Litterati Community.
                                    The open data is currently the community's raw data. We will work over time to
                                    improve the data quality by applying the community`}{' '}
                                    <a
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        href="https://drive.google.com/drive/folders/1OLeeF2nmUZxYd0jkmOz7XOwW9GOne7Gj"
                                    >
                                        taxonomy
                                    </a>{' '}
                                    & applying LitterAI.
                                </p>
                                <p>
                                    Currently about 80% of the data has been
                                    tagged by the community and there are over
                                    90,000 unique labels. We have filtered on
                                    the top 5,000 tags into a taxonomy based on
                                    the litter’s <br /> Object, Material, and
                                    Brand.
                                </p>
                                <p>
                                    You can see the classification{' '}
                                    <a
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        href="https://litterati-tag-manager.netlify.app/"
                                    >
                                        here
                                    </a>{' '}
                                    as a snapshot from our data at the end of
                                    2019
                                </p>
                                <p>
                                    We are open to thoughts & suggestions for
                                    ways to improve the quality of this raw data
                                    to maximize your potential impact. Feel free
                                    to share any ideas through the above contact
                                    form.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

RequestForm.propTypes = {
    onFormSubmit: PropTypes.func,

    formMessage: PropTypes.number,

    onMessageDisplay: PropTypes.func,

    isFormSubmissionRequested: PropTypes.bool,
};

RequestForm.defaultProps = {
    formMessage: 0,
    isFormSubmissionRequested: false,
};

const mapStateToProps = (state) => {
    return {
        formMessage: getFormMessage(state),
        isFormSubmissionRequested: isFormSubmitting(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onFormSubmit: (
            name,
            email,
            phone,
            organization,
            purpose,
            reference,
            extraInfo,
            expandedData,
        ) =>
            dispatch(
                formSubmissionRequested(
                    name,
                    email,
                    phone,
                    organization,
                    purpose,
                    reference,
                    extraInfo,
                    expandedData,
                ),
            ),
        onMessageDisplay: () => dispatch(clearFormMessage()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RequestForm);
